const typeGetter = /\[object\s([a-z]+)\]/
export const typeOf = input => Object.prototype.toString.call(input).toLowerCase().replace(typeGetter, '$1')

export default typeOf
